import { render, staticRenderFns } from "./PayServiceInfo.vue?vue&type=template&id=4cc3bcef&scoped=true&"
import script from "./PayServiceInfo.vue?vue&type=script&lang=ts&"
export * from "./PayServiceInfo.vue?vue&type=script&lang=ts&"
import style0 from "./PayServiceInfo.vue?vue&type=style&index=0&id=4cc3bcef&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../boss_taobao/client/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cc3bcef",
  null
  
)

export default component.exports